import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getUserAll(pageNum) {
  return request({
    url: '/user/getUserList',
    params: {
      pageNum: pageNum
    }
  })
}

export function getUserBySearch(username,umsClassify,phoneNumber,email,shareCode,pageNum,pageSize) {
  return request({
    url: '/user/getUserList',
    params: {
      username: username,
      umsClassify: umsClassify,
      phoneNumber: phoneNumber,
      email: email,
      shareCode:shareCode,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function getShareBySearch(inviterShareCode,pageNum,pageSize) {
  return request({
    url: '/user/getShareList',
    params: {
      inviterShareCode: inviterShareCode,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function getUserById(userId) {
  return request({
    url: '/user/getById',
    params: {
      userId:userId
    }
  })
}

export function sealById(userId) {
  return requestMsg({
    url: '/user/sealById',
    params: {
      userId:userId
    }
  })
}

export function getPassword(userId) {
  return requestMsg({
    url: '/user/getPassword',
    params: {
      userId:userId
    }
  })
}

export function unsealById(userId) {
  return requestMsg({
    url: '/user/unsealById',
    params: {
      userId:userId
    }
  })
}

export function disableById(userId) {
  return requestMsg({
    url: '/user/disableById',
    params: {
      userId:userId
    }
  })
}

// export class Goods {
//   constructor(itemInfo,columns,services) {
//     this.title = itemInfo.title;
//     this.desc = itemInfo.desc;
//     this.newPrice = itemInfo.price;
//     this.oldPrice = itemInfo.oldPrice;
//     this.discount = itemInfo.discountDesc;
//     this.columns = columns;
//     this.services = services;
//     this.realPrice = itemInfo.lowNowPrice;
//   }
// }
